module.exports = "/assets/data/a73cc4893609fc35c6cbde595c3c2e02-CW8.data.json";